import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2848a956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cantainer" }
const _hoisted_2 = { class: "top-section" }
const _hoisted_3 = {
  class: "que_status",
  "text-center": ""
}
const _hoisted_4 = { class: "text label" }
const _hoisted_5 = { class: "ion-text-center" }
const _hoisted_6 = { class: "ion-margin-top" }

import {
  // IonButtons,
  IonContent,
  // IonHeader,
  // IonMenuButton,
  IonPage,
  // IonTitle,
  // IonToolbar,
  IonCol,
  IonRow,
  IonListHeader,
  IonItem,
  IonList,
  IonLabel,
  IonIcon,
  IonButton,
} from '@ionic/vue';
import {
  checkmarkCircleOutline,
  closeCircleOutline,
  radioButtonOnOutline
} from 'ionicons/icons';
import MatchesService from "@/api/matches/MatchesService";
import {useRoute, useRouter} from "vue-router";
import {computed, ref} from 'vue'
import VueCountdown from '@chenfengyuan/vue-countdown'
// import './quiz.scss'



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();

const quizResult = ref<any>([])

const blankAnswerClicked = {
  clicked: false,
  question: {},
  answer: {},
  index: null,
}

const answerClicked = ref(JSON.parse(JSON.stringify(blankAnswerClicked)))
const resetAnswerClicked = () => {
  answerClicked.value = JSON.parse(JSON.stringify(blankAnswerClicked))
}

const nextAnswer = ref<any>(0)
const questionTime = ref(JSON.parse(localStorage.getItem('currentClass') || '{}'))
const startTimer = ref(true)

const {
  fetchMatch,
  getCurrentMatch,
  saveMatchResult,
} = MatchesService()
fetchMatch({'match_id': route.params.id})

const currentQuiz = computed(() => getCurrentMatch())

const transformSlotProps = props => {
  const formattedProps = {};
  Object.entries(props).forEach(([key, value]) => {
    formattedProps[key] = value < 10 ? `0${value}` : String(value);
  });
  return formattedProps;
}

const nextQuestion = () => {
  if (!answerClicked.value.clicked) {
    quizResult.value.push({
      question: getCurrentMatch().quiz.quiz[nextAnswer.value],
      answer: null,
    })
  } else {
    quizResult.value.push({
      question: answerClicked.value.question,
      answer: answerClicked.value.answer,
    })
  }

  nextAnswer.value += 1
  resetAnswerClicked()

  if (nextAnswer.value === currentQuiz.value.quiz.quiz.length) {
    saveMatchResult({
      id: currentQuiz.value.id,
      quiz: quizResult.value,
      switalyPoints: Math.round(currentQuiz.value.quiz.quiz.length / 100 * 80)
    })
    nextAnswer.value = 0
    router.replace({ path: 'congratulations' })
  } else {
    startTimer.value = !startTimer.value
  }
}

const getResponse = (question, answer, index) => {
  answerClicked.value.clicked = true
  answerClicked.value.question = question
  answerClicked.value.answer = answer
  answerClicked.value.index = index
}


return (_ctx: any,_cache: any) => {
  return (_unref(currentQuiz).quiz && nextAnswer.value+1 <= _unref(currentQuiz).quiz.quiz.length)
    ? (_openBlock(), _createBlock(_unref(IonPage), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonContent), {
            class: "bg-light",
            "padding-left": "",
            "padding-right": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(IonRow), { class: "row" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), {
                        size: "3",
                        class: "col"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(nextAnswer.value + 1) + "/" + _toDisplayString(_unref(currentQuiz).quiz.quiz.length), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCol), {
                        size: "6",
                        class: "col"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_unref(VueCountdown), {
                              key: startTimer.value,
                              time: parseInt(questionTime.value.match_duration)*1000,
                              transform: transformSlotProps,
                              onEnd: nextQuestion
                            }, {
                              default: _withCtx(({ minutes, seconds }) => [
                                _createElementVNode("h2", null, _toDisplayString(minutes ? minutes + ':' : '') + _toDisplayString(seconds), 1)
                              ]),
                              _: 1
                            }, 8, ["time"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCol), {
                        size: "3",
                        class: "col"
                      })
                    ]),
                    _: 1
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentQuiz).quiz.quiz, (question, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: question.id
                  }, [
                    (nextAnswer.value === index)
                      ? (_openBlock(), _createBlock(_unref(IonList), {
                          key: 0,
                          "no-lines": "",
                          class: "border-rouded list",
                          lines: "none"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonListHeader), null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createElementVNode("p", null, _toDisplayString(question.question), 1)
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
                              return (_openBlock(), _createBlock(_unref(IonItem), {
                                key: answer.id,
                                class: "options item",
                                onClick: ($event: any) => (getResponse(question, answer, index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", _hoisted_5, _toDisplayString(answer.text), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (answerClicked.value.clicked && answerClicked.value.answer.id === answer.id)
                                    ? (_openBlock(), _createBlock(_unref(IonIcon), {
                                        key: 0,
                                        src: _unref(radioButtonOnOutline)
                                      }, null, 8, ["src"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (nextQuestion())),
                    disabled: !answerClicked.value.clicked
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(nextAnswer.value + 1 === _unref(currentQuiz).quiz.quiz.length ? 'Concludi' : 'Avanti'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})